// extracted by mini-css-extract-plugin
export var phone = "_45-0";